import { render, staticRenderFns } from "./part-all.vue?vue&type=template&id=037001f8&scoped=true"
import script from "./part-all.vue?vue&type=script&lang=js"
export * from "./part-all.vue?vue&type=script&lang=js"
import style0 from "./part-all.vue?vue&type=style&index=0&id=037001f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037001f8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonGridRow: require('/builds/wj/fe/wenjuan-homesite/components/common/grid-row.vue').default})
